'use client';

import type React from 'react';

import { ActiveTrue } from '@shared/icons';
import type { SuggestionItemProps } from '../types';

function SuggestionItem({ id, suggestion, index, isHighlighted, onSelect, onMouseEnter, onKeyDown }: SuggestionItemProps) {
  // Prevent default on mousedown to maintain focus
  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <div
      id={`${id}-suggestion-${index}`}
      role="option"
      aria-selected={isHighlighted}
      className="w-full text-left p-2 h-10 flex items-center cursor-pointer data-[highlighted=true]:bg-container"
      data-highlighted={isHighlighted}
      data-testid={`suggestion-item-${index}`}
      onClick={() => onSelect(suggestion)}
      onKeyDown={e => onKeyDown(e, suggestion)}
      onMouseEnter={() => onMouseEnter(index)}
      onMouseDown={handleMouseDown}
      tabIndex={0}
    >
      <ActiveTrue size="extra-small" className="flex-shrink-0" />
      <div className="flex items-center ml-3 truncate">
        <div className="mr-1 btn-label-s truncate text-foreground" data-testid="suggestion-text">
          {suggestion.Text}
        </div>
        {suggestion.Description && (
          <div className="btn-label-light truncate text-foreground" data-testid="suggestion-description">
            {suggestion.Description}
          </div>
        )}
      </div>
    </div>
  );
}

export { SuggestionItem };
